export default {
  name: 're-loading',
  props: {
    classes: {
      type: [String, Array, Object],
      default: null
    },
    withLoader: {
      type: [Boolean, Number, String],
      default: true
    },
    loadingMessage: {
      type: String,
      default: ''
    },
  },
}
